import { Header, Spinner } from 'view/components';
/* import { useMediaQuery } from '@mui/material';
import { theme } from 'view/themes/theme'; */
import {
  FAVORITE_CANDIDATES_ITEMS_PER_PAGE,
  useGetFavoriteCandidates,
} from 'view/pages/candidates/hooks/useGetFavoriteCandidates';
import { useEffect, useState } from 'react';
import { CandidateListItem, NoResultsBlock } from 'view/pages/candidates/components';
import * as CS from 'view/pages/candidates/commonStyled';
import { useNavigate } from 'react-router';
import * as S from './styled';

const FavoriteCandidatesPage = () => {
  const navigate = useNavigate();
  /* const matches = useMediaQuery(theme.breakpoints.down('laptop')); */
  const [page, setPage] = useState(1);

  const { isLoading, getFavoriteCandidates, data } = useGetFavoriteCandidates();

  useEffect(() => {
    getFavoriteCandidates();
  }, []);

  return (
    <S.Wrapper>
      <Header />
      {/* <S.BreadcrumbsContainer /> */}
      <S.MainContentWrapper>
        {isLoading && (
          <Spinner
            variant="outlined"
            style={{
              position: 'absolute',
              top: '0',
              left: '0',
              backgroundColor: 'rgba(217, 225, 255, 0.3)',
              width: '100%',
              height: '100%',
              zIndex: 10,
            }}
          />
        )}
        {!isLoading && !data?.total && (
          <NoResultsBlock
            title="No saved candidates yet"
            subTitle={
              <p>
                You can save candidates{' '}
                <span
                  style={{ color: '#663497', cursor: 'pointer' }}
                  onClick={() => {
                    navigate('/candidates/candidates-list');
                  }}
                >
                  here
                </span>{' '}
                to view them later.
              </p>
            }
          />
        )}
        {data?.total && !!data?.data?.length ? (
          <>
            <S.CandidatesListBlockMainWrapper>
              <>
                {data?.data?.map((item) => {
                  return (
                    <CandidateListItem
                      candidate={item}
                      key={item.id}
                      successFunction={() => {
                        if (data?.data?.length === 1 && page !== 1) {
                          getFavoriteCandidates(page - 1);
                          setPage(page - 1);
                          return;
                        }
                        getFavoriteCandidates(page);
                      }}
                    />
                  );
                })}
              </>
            </S.CandidatesListBlockMainWrapper>
            <CS.CustomPagination
              count={Math.ceil(data.total / FAVORITE_CANDIDATES_ITEMS_PER_PAGE)}
              shape="rounded"
              page={page}
              onChange={(e, page) => {
                setPage(page);
                getFavoriteCandidates(page);
              }}
              style={{ margin: 'auto auto 0' }}
            />
          </>
        ) : null}
      </S.MainContentWrapper>
    </S.Wrapper>
  );
};

export default FavoriteCandidatesPage;
